import {parallaxAnimation} from './parallaxAnimation';
import {imageRevealAnimation} from './imagesRevealAnimation';
import {wordsUpAnimation} from './wordsUpAnimation';
import {linesUpAnimation} from './linesUpAnimation';
import {inViewAnimations} from './InViewAnimations';
import {realLinesUpAnimation} from './RealLinesUpAnimation';
import {spriteSheetAnimation} from "./spriteSheetAnimation";
import {drawDottedLineAnimation} from "./drawDottedLineAnimation";
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {getElementsForAnimation} from '../../functions/getElementsForAnimation';

gsap.registerPlugin(ScrollTrigger)


export function animations(container = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const animatedElements = getElementsForAnimation(
        container,
        '[class^="iv-st"], [class*=" iv-st"], .word-up, .line-up, .real-line-up',
    );
    gsap.set(animatedElements, {
      clearProps: 'opacity,visibility,transform',
    });
    return;
  }

  imageRevealAnimation(container);
  wordsUpAnimation(container);
  linesUpAnimation(container);
  inViewAnimations(container);
  spriteSheetAnimation(container);
  parallaxAnimation(container);
  realLinesUpAnimation(container);
  drawDottedLineAnimation(container);
}
